import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const ProtectedRestaurantRoute = ({ children }) => {
  const { admin, checking } = useAuth();
  if (checking) return <div className="min-h-[50vh] flex items-center justify-center text-navy/50">Loading…</div>;
  if (!admin) return <Navigate to="/restaurant-admin/login" replace />;
  if (admin.role === "admin") return <Navigate to="/admin" replace />;
  if (admin.role === "rider") return <Navigate to="/rider" replace />;
  return children;
};

export default ProtectedRestaurantRoute;
